import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { wishListActions } from '../../../redux/wishList/actions/WishListActions.creators';
import { AddToWishlistButtonAlpha } from '../add-to-wishlist-button/AddToWishlistButtonAlpha';
import { makeGetProductColorIsInWishList } from '../../../redux/wishList/selectors/WishListSelectors';
export const ProductMediaWishListButton = ({ wishListProduct }) => {
    const productColorIsInWishList = useSelector(makeGetProductColorIsInWishList());
    const dispatch = useDispatch();
    const handleToggleWishlist = () => {
        dispatch(wishListActions.toggleProduct(wishListProduct));
    };
    return (_jsx(AddToWishlistButtonAlpha, { isProductInWishList: productColorIsInWishList, onToggle: handleToggleWishlist, wishListProduct: wishListProduct }));
};
